import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import React from 'react';

import Navbar from './actions/components/navbar/Navbar';
import Sidebar from './actions/components/Sidebar/Sidebar';
import Dashboard from './actions/views/Dashboard/Dashboard';
import Alerts from './actions/views/Alerts/Alerts';
import Buildings from './actions/views/Buildings/Buildings';
import Banks from './actions/views/Buildings/Banks';
import Devices from './actions/views/Buildings/Devices';
import Page from './actions/views/Buildings/Page';
import Settings from './actions/views/Settings/Settings';
import Reporting from './actions/views/Reporting/Reporting';
import Login from './actions/views/Login/Login';
import Forgot from './actions/views/Forgot/Forgot';
import Profile from './actions/views/Profile/Profile';
import AllEvents from './actions/views/Events/AllEvents';
import DeviceStatistics from './actions/views/Buildings/DeviceStatistics';
import NewAlternateView from './actions/views/NewAlternateView/NewAlternateView';
import AlternateView from './actions/views/AlternateView/AlternateView';

import useAuthRedirect from './hooks/useAuthRedirect';
import ROUTES from './utils/constants/endpoints';
import {AuthProvider} from "./context/AuthContext";
import {Toaster} from "sonner";

function App() {
  return (
      <AuthProvider>
        <BrowserRouter>
          <AuthWrapper />
          <Toaster closeButton={true} theme="dark" />
        </BrowserRouter>
      </AuthProvider>
  );
}

function AuthWrapper() {
  const isLoggedIn = useAuthRedirect();

  return (
      <div className="app-container">
        {isLoggedIn && <Navbar />}

        <div className='page-components'>
          {isLoggedIn && (
              <div className="sidebar-component">
                <Sidebar />
              </div>
          )}

          <div className="main-component">
            <Routes>
              {/* Public Routes */}
              <Route path={ROUTES.LOGIN} element={<Login />} />
              <Route path={ROUTES.FORGOT_PASSWORD} element={<Forgot />} />

              {/* Protected Routes */}
              {isLoggedIn && (
                  <>
                    <Route path={ROUTES.DASHBOARD} element={<Dashboard />} />
                    <Route path={ROUTES.ALERTS} element={<Alerts />} />
                    <Route path={ROUTES.BUILDINGS} element={<Page />}>
                      <Route index element={<Buildings />} />
                      <Route path={ROUTES.BANKS} element={<Banks />} />
                      <Route path={ROUTES.DEVICES} element={<Devices />} />
                      <Route path={ROUTES.DEVICE_STATS} element={<DeviceStatistics />} />
                    </Route>
                    <Route path={ROUTES.SETTINGS} element={<Settings />} />
                    <Route path={ROUTES.REPORTS} element={<Reporting />} />
                    <Route path={ROUTES.PROFILE} element={<Profile />} />
                    <Route path={ROUTES.EVENTS} element={<AllEvents />} />

                  </>
              )}

              {/* Alternate Views */}
              <Route path={ROUTES.ALTERNATE_VIEW} element={<AlternateView />} />
              <Route path={ROUTES.NEW_ALTERNATE_VIEW} element={<NewAlternateView />} />
            </Routes>
          </div>
        </div>
      </div>
  );
}

export default App;
